import {
  CalendarMonth,
  EditNotifications,
  Email,
  SatelliteAlt,
  Groups,
  ManageAccounts,
} from '@mui/icons-material';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import PromptIcon from '@mui/icons-material/Memory';
import { BiUpload } from 'react-icons/bi';
// import { IoPrismSharp } from 'react-icons/io5';
import { MdOutlineHelpOutline } from 'react-icons/md';
import { SiTorbrowser } from 'react-icons/si';

export const teamsAndUsersOptionsForUser = [
  {
    label: 'Manage Teams',
    url: '/teams',
    icon: <Groups />,
  },
];
export const teamsAndUsersOptionsAccess = [
  {
    label: 'Manage Teams',
    url: '/teams',
    icon: <Groups />,
  },
  { label: 'Manage Users', url: '/users', icon: <ManageAccounts />, SKU: '' },
];
export const accountOptionsForUser = [
  {
    label: 'Notification Settings',
    url: '/notification-settings',
    icon: <EditNotifications />,
  },
];

export const faqOptionsForUser = [
  {
    label: 'FAQs',
    url: '/faqs/jobs',
    icon: <MdOutlineHelpOutline />,
  },
  {
    label: 'Help Videos',
    url: '/faqs/job-videos',
    icon: <MdOutlineHelpOutline />,
  },
];

export const appsAndIntegrationsOptionsForUser = [
  {
    label: 'Communication Accounts',
    url: '/sms-configuration',
    icon: <SatelliteAlt />,
    SKU: '',
  },
  { label: 'Email Settings', url: '/email-settings/', icon: <Email />, SKU: '' },
  {
    label: 'Templates',
    url: '/template-settings/email-template-settings',
    icon: <Email />,
    SKU: '',
  },
  // {
  //   label: 'Prism Extension',
  //   url: '/prism-download',
  //   icon: <IoPrismSharp />,
  //   SKU: '',
  // },
  {
    label: 'CV Uploader App',
    url: '/bulk-importer',
    icon: <BiUpload />,
    SKU: '',
  },
  {
    label: 'Outlook Extension',
    url: 'https://appsource.microsoft.com/en-us/product/office/WA200002649?tab=Overview',
    icon: <SiTorbrowser />,
    openInNewTab: true,
    SKU: '',
  },
  {
    label: 'Browser Extension',
    url: 'https://chrome.google.com/webstore/detail/recruitment-automation-by/dhbkmcoahmolllnkkpgniamjkldaemgm',
    icon: <SiTorbrowser />,
    openInNewTab: true,
    SKU: '',
  },
  // {
  //   label: 'Private Extension',
  //   url: '/private-extension/',
  //   icon: <SiTorbrowser />,
  //   SKU: '',
  // },
  {
    label: 'Resume Parsing by Email ',
    url: '/resume-parsing-by-email/',
    icon: <Email />,
    SKU: '',
  },
  {
    label: 'Create Leads via Email ',
    url: '/leads-email',
    icon: <FolderCopyIcon />,
    SKU: '',
  },
  {
    label: 'Create Notes via Email ',
    url: '/notes-email',
    icon: <FolderCopyIcon />,
    SKU: '',
  },
  { label: 'Calendar', url: '/calender-settings', icon: <CalendarMonth /> },
];

export const appsAndIntegrationsOptionsForCrusibleUser = [
  {
    label: 'Communication Accounts',
    url: '/sms-configuration',
    icon: <SatelliteAlt />,
    SKU: '',
  },
  { label: 'Email Settings', url: '/email-settings/', icon: <Email />, SKU: '' },
  {
    label: 'Templates',
    url: '/template-settings/email-template-settings',
    icon: <Email />,
    SKU: '',
  },
  {
    label: 'CV Uploader App',
    url: '/bulk-importer',
    icon: <BiUpload />,
    SKU: '',
  },
  {
    label: 'Outlook Extension',
    url: 'https://appsource.microsoft.com/en-us/product/office/WA200002649?tab=Overview',
    icon: <SiTorbrowser />,
    openInNewTab: true,
    SKU: '',
  },
  {
    label: 'Browser Extension',
    url: 'https://chrome.google.com/webstore/detail/recruitment-automation-by/dhbkmcoahmolllnkkpgniamjkldaemgm',
    icon: <SiTorbrowser />,
    openInNewTab: true,
    SKU: '',
  },
  {
    label: 'Resume Parsing by Email ',
    url: '/resume-parsing-by-email/',
    icon: <Email />,
    SKU: '',
  },
  { label: 'Calendar', url: '/calender-settings', icon: <CalendarMonth /> },
  { label: 'Prompt Settings', url: '/prompt-settings', icon: <PromptIcon /> },
];
